import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Card, Button } from "react-bootstrap";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import ChatHistoryView from "./ChatHistoryView";

function UserChatList(params) {
  console.log("params", params.userChatList);
  const userChatList = params.userChatList;
  console.log("userChatList", userChatList);
  const { t } = useTranslation();

  const [showChatModal, setShowChatModal] = useState(false);
  const [selectedMeetingCode, setSelectedMeetingCode] = useState(null);

  const handleViewClick = (meetingCode) => {
    setSelectedMeetingCode(meetingCode);
    setShowChatModal(true);
    console.log("meetingCode", meetingCode);
  };

  const columns = [
    { field: "conName", headerName: "CONSULTANT", width: 150 },
    { field: "chatDate", headerName: "CHAT DATE", width: 150 },
    { field: "connectStartTime", headerName: "CONNECT START TIME", width: 150 },
    { field: "chatStartTime", headerName: "CHAT START TIME", width: 150 },
    { field: "connectEndTime", headerName: "CONNECT END TIME", width: 150 },
    {
      field: "proposedChatDuration",
      headerName: "PROPOSED DURATION",
      width: 150,
    },
    { field: "duration", headerName: "DURATION", width: 140 },
    { field: "status", headerName: "STATUS", width: 180 },
    {
      field: "chatview",
      headerName: "CHAT VIEW",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) =>
        params.row.duration > 0 ? (
          <Button
            className="mx-1 all_btn"
            onClick={() => {
              handleViewClick(params.row.meetingCode);
              console.log("params", params);
            }}
          >
            View
          </Button>
        ) : (
          <span>--</span>
        ),
    },
    { field: "chatType", headerName: "CHAT TYPE", width: 150 },
  ];

  return (
    <div>
      <center>
        <h4>
          <u>Chat Details</u>
        </h4>
      </center>
      {userChatList.length > 0 ? (
        <>
          <center className="datagrid">
            <Grid container className="deskTable">
              <DataGrid
                className="all_border - text-center me-3 data_grid"
                rows={[...userChatList].reverse()}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 5 },
                  },
                }}
                pageSizeOptions={[5, 10]}
                getRowId={(row) => row.id}
              />
            </Grid>
          </center>

          <div className="mobileCard">
            {userChatList.map((i, j) => (
              <Card
                className="mobileCard all_border"
                key={j}
                style={{
                  width: "100%",
                  marginBottom: "10px",
                  backgroundColor: "antiquewhite",
                }}
              >
                <Card.Body>
                  <Card.Subtitle className="mb-2">
                    <b>Consultant:</b> {i.conName}
                  </Card.Subtitle>
                  <Card.Subtitle className="mb-2">
                    <b>Chat Type:</b> {i.chatType}
                  </Card.Subtitle>
                  <Card.Subtitle className="mb-2">
                    <b>Start Time:</b> {i.connectStartTime}
                  </Card.Subtitle>
                  <Card.Subtitle className="mb-2">
                    <b>Duration:</b> {i.duration}
                  </Card.Subtitle>
                  <Card.Subtitle className="mb-2">
                    <b>Proposed Duration:</b> {i.proposedChatDuration}
                  </Card.Subtitle>
                  <Card.Subtitle className="mb-2">
                    <b> Status:</b> {i.status}
                  </Card.Subtitle>
                  <Card.Subtitle className="mb-2">
                    <b className="me-1">Action:</b>
                    {i.duration > 0 ? (
                      <Button
                        className="mx-1 all_btn"
                        onClick={() => handleViewClick(i.meetingCode)}
                      >
                        View
                      </Button>
                    ) : (
                      <span>--</span>
                    )}
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            ))}
          </div>
        </>
      ) : (
        <center>
          <h5>{t("TXT.NO.REC.FUD.LO")}</h5>
        </center>
      )}

      <ChatHistoryView
        show={showChatModal}
        onClose={() => setShowChatModal(false)}
        meetingCode={selectedMeetingCode}
      />
    </div>
  );
}

export default UserChatList;
